export function setCursor(element: HTMLElement, cursor?: string | null): void {
  element.style.cursor = cursor ?? '';
}
